import React, { useCallback, useEffect, useState } from 'react';
import { getPlazas } from '../../../api/plazas';
import { getSportsSeason, getSportsSeasons, mutateSportsSeason, sportsEndpoint } from '../../../api/sportsSchedules';
import { getSelectedEnvironment } from '../../../utils/apiEnvironment';
import { SELECTION_COPY } from './sportsCopy';
import SportsWorkspace from './SportsWorkspace';
import SportsPromotion from './SportsPromotion';
export default function SportsSchedules({ environment, token, role, copy, locale, onDirty }) {
  const [collection, setCollection] = useState(null), [detail, setDetail] = useState(null), [plazas, setPlazas] = useState(null);
  const [loading, setLoading] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState(''), [notice, setNotice] = useState(''), [uncertain, setUncertain] = useState(null);
  const enabled = environment === 'test' && !!token && role === 'admin';
  const initialLoad = useCallback(async () => {
    if (!enabled) return;
    setLoading(true); setError('');
    try { const [list, plazaData] = await Promise.all([getSportsSeasons(token, environment), getPlazas(token, environment)]); setCollection(list); setPlazas(plazaData.items.filter(item => item.planet_id === 1)); }
    catch (failure) { setError(failure.message); setPlazas(null); }
    finally { setLoading(false); }
  }, [enabled, token, environment]);
  useEffect(() => { initialLoad(); }, [initialLoad]);
  async function open(id) {
    if (!enabled || busy || uncertain) return;
    setLoading(true); setError(''); setNotice('');
    try { const current = await getSportsSeason(id, token, environment); setDetail(current); setCollection(previous => ({ ...previous, config_revision: current.config_revision })); }
    catch (failure) { setError(failure.message); }
    finally { setLoading(false); }
  }
  function successMessage(kind) { if (kind === 'include' || kind === 'exclude') return (SELECTION_COPY[locale] || SELECTION_COPY.en)[kind === 'include' ? 'includeDone' : 'excludeDone']; return kind === 'draft' ? copy.saved : kind === 'review' ? copy.reviewDone : kind === 'publish' ? copy.publishDone : copy.unpublishDone; }
  async function refresh() {
    if (busy || loading) return;
    await initialLoad();
    if ((uncertain || detail) && enabled) {
      setLoading(true);
      try {
        const current = await getSportsSeason(uncertain?.id || detail.season.id, token, environment);
        if (!uncertain) { setDetail(current); setCollection(previous => ({ ...previous, config_revision: current.config_revision })); }
        else if (current.config_revision === uncertain.operationId) { setDetail(current); setUncertain(null); setError(''); setNotice(successMessage(uncertain.kind)); }
        else setError(copy.unknown);
      } catch (failure) { setError(`${copy.unknown} ${failure.message}`); }
      finally { setLoading(false); }
    }
  }
  async function action(operation) {
    if (!enabled || getSelectedEnvironment() !== environment || busy || (uncertain && JSON.stringify(operation) !== JSON.stringify(uncertain))) return;
    setBusy(true); setError(''); setNotice('');
    let committed = false;
    try {
      await mutateSportsSeason(operation, token, environment); committed = true;
      // Replays can return an older successful operation; always render current reads.
      const [list, current, plazaData] = await Promise.all([getSportsSeasons(token, environment), getSportsSeason(operation.id, token, environment), getPlazas(token, environment)]);
      setCollection(list); setDetail(current); setPlazas(plazaData.items.filter(item => item.planet_id === 1));
      setUncertain(null); setNotice(successMessage(operation.kind));
    } catch (failure) {
      if (committed || !failure.status || failure.status >= 500) { setUncertain(operation); setError(copy.unknown); }
      else { setUncertain(null); setError(failure.status === 412 ? copy.conflict : failure.message); }
    } finally { setBusy(false); }
  }
  return <><SportsWorkspace collection={collection} detail={detail} plazas={plazas} copy={copy} locale={locale} environment={environment.toUpperCase()} endpoint={sportsEndpoint(environment)} loading={loading} busy={busy} error={error} notice={notice} uncertain={uncertain} writesEnabled={enabled} onRefresh={refresh} onOpen={open} onAction={action} onDirty={onDirty} /><SportsPromotion detail={detail} environment={environment} token={token} role={role} locale={locale} onDirty={onDirty} /></>;
}
